"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableStagger = exports.handleStaggeredButtons = void 0;
const audioHandler_1 = require("./audioHandler");
const __1 = require("../../..");
const camelize_1 = require("./camelize");
const taskStore_1 = require("../../../taskStore");
let staggerEnabled = true;
const handleStaggeredButtons = async (pageState, buttonContainer, audioList, currentTrialId, disableButtons = true) => {
    const parentResponseDiv = buttonContainer;
    let i = 0;
    const stimulusDuration = await pageState.getStimulusDurationMs();
    const intialDelay = stimulusDuration + 300;
    staggerEnabled = true;
    // Disable the replay button till this animation is finished
    setTimeout(() => {
        pageState.disableReplayBtn();
    }, stimulusDuration + 110);
    if (disableButtons) {
        for (const jsResponseEl of parentResponseDiv.children) {
            // disable the buttons so that they are not active during the animation
            jsResponseEl.classList.add('lev-staggered-responses', 'lev-staggered-disabled', 'lev-staggered-grayscale', 'lev-staggered-opacity');
        }
    }
    // Return a Promise that resolves when the staggered animation is complete
    return new Promise((resolve) => {
        setTimeout(() => {
            showStaggeredBtnAndPlaySound(0, Array.from(parentResponseDiv === null || parentResponseDiv === void 0 ? void 0 : parentResponseDiv.children), audioList, pageState, resolve, // Pass the resolve function to be called when animation completes
            currentTrialId);
        }, intialDelay);
    });
};
exports.handleStaggeredButtons = handleStaggeredButtons;
const showStaggeredBtnAndPlaySound = (index, btnList, audioList, pageState, onComplete, currentTrialId) => {
    var _a;
    // check if the trial id has changed - we don't want overlap between trials
    const actualTrialId = (_a = (0, taskStore_1.taskStore)().nextStimulus) === null || _a === void 0 ? void 0 : _a.itemId;
    if (!staggerEnabled || (currentTrialId && currentTrialId !== actualTrialId)) {
        return;
    }
    const btn = btnList[index];
    btn.classList.remove('lev-staggered-grayscale', 'lev-staggered-opacity');
    let audioAsset = __1.mediaAssets.audio[(0, camelize_1.camelize)(audioList[index])];
    if (!audioAsset) {
        console.error('Audio Asset not available for:', audioList[index]);
        audioAsset = __1.mediaAssets.audio.nullAudio;
    }
    const audioConfig = {
        restrictRepetition: {
            enabled: false,
            maxRepetitions: 2,
        },
        onEnded: () => {
            var _a;
            const actualTrialId = (_a = (0, taskStore_1.taskStore)().nextStimulus) === null || _a === void 0 ? void 0 : _a.itemId;
            if (!staggerEnabled || (currentTrialId && currentTrialId !== actualTrialId)) {
                return;
            }
            if (index + 1 === (btnList === null || btnList === void 0 ? void 0 : btnList.length)) {
                // Last Element
                for (const jsResponseEl of btnList) {
                    jsResponseEl.classList.remove('lev-staggered-disabled');
                }
                pageState.enableReplayBtn();
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            }
            else {
                //recurse
                showStaggeredBtnAndPlaySound(index + 1, btnList, audioList, pageState, onComplete, currentTrialId);
            }
        },
    };
    audioHandler_1.PageAudioHandler.playAudio(audioAsset, audioConfig);
};
const disableStagger = () => {
    staggerEnabled = false;
};
exports.disableStagger = disableStagger;
